var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutSourcing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7221 18.0215C20.8857 18.0215 18.5864 20.3208 18.5864 23.1571C18.5864 25.9934 20.8857 28.2927 23.7221 28.2927C26.5584 28.2927 28.8577 25.9934 28.8577 23.1571C28.8577 20.3208 26.5584 18.0215 23.7221 18.0215ZM15.5864 23.1571C15.5864 18.6639 19.2289 15.0215 23.7221 15.0215C28.2152 15.0215 31.8577 18.6639 31.8577 23.1571C31.8577 27.6503 28.2152 31.2927 23.7221 31.2927C19.2289 31.2927 15.5864 27.6503 15.5864 23.1571Z",
    fill: "#F3F4F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8218 43.0633C10.8218 36.8256 16.9055 32.2734 23.7218 32.2734C30.5381 32.2734 36.6218 36.8256 36.6218 43.0633C36.6218 43.8917 35.9502 44.5633 35.1218 44.5633C34.2933 44.5633 33.6218 43.8917 33.6218 43.0633C33.6218 39.029 29.4866 35.2734 23.7218 35.2734C17.957 35.2734 13.8218 39.029 13.8218 43.0633C13.8218 43.8917 13.1502 44.5633 12.3218 44.5633C11.4934 44.5633 10.8218 43.8917 10.8218 43.0633Z",
    fill: "#F3F4F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7212 3.22168C24.5496 3.22168 25.2212 3.89325 25.2212 4.72168V11.9217C25.2212 12.7501 24.5496 13.4217 23.7212 13.4217C22.8928 13.4217 22.2212 12.7501 22.2212 11.9217V4.72168C22.2212 3.89325 22.8928 3.22168 23.7212 3.22168Z",
    fill: "#F3F4F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6604 2.46082C23.2462 1.87504 24.196 1.87504 24.7818 2.46082L28.3818 6.06082C28.9675 6.64661 28.9675 7.59636 28.3818 8.18214C27.796 8.76793 26.8462 8.76793 26.2604 8.18214L23.7211 5.6428L21.1818 8.18214C20.596 8.76793 19.6462 8.76793 19.0604 8.18214C18.4746 7.59636 18.4746 6.64661 19.0604 6.06082L22.6604 2.46082Z",
    fill: "#F3F4F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2169 6.85558C43.8027 7.44137 43.8027 8.39112 43.2169 8.9769L38.1257 14.0681C37.54 14.6539 36.5902 14.6539 36.0044 14.0681C35.4186 13.4823 35.4186 12.5325 36.0044 11.9468L41.0956 6.85558C41.6814 6.2698 42.6311 6.2698 43.2169 6.85558Z",
    fill: "#F3F4F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0051 5.5673C43.8335 5.5673 44.5051 6.23887 44.5051 7.0673V12.1585C44.5051 12.9869 43.8335 13.6585 43.0051 13.6585C42.1766 13.6585 41.5051 12.9869 41.5051 12.1585V8.56729H37.9139C37.0855 8.56729 36.4139 7.89572 36.4139 7.0673C36.4139 6.23887 37.0855 5.5673 37.9139 5.5673H43.0051Z",
    fill: "#F3F4F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45421 6.85536C5.04 6.26957 5.98975 6.26957 6.57554 6.85536L11.6667 11.9465C12.2525 12.5323 12.2525 13.4821 11.6667 14.0678C11.0809 14.6536 10.1312 14.6536 9.54538 14.0678L4.45421 8.97668C3.86843 8.39089 3.86843 7.44114 4.45421 6.85536Z",
    fill: "#F3F4F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1669 7.0677C3.1669 6.23927 3.83848 5.5677 4.6669 5.5677H9.75807C10.5865 5.5677 11.2581 6.23927 11.2581 7.0677C11.2581 7.89612 10.5865 8.5677 9.75807 8.5677H6.1669L6.1669 12.1589C6.1669 12.9873 5.49533 13.6589 4.6669 13.6589C3.83848 13.6589 3.1669 12.9873 3.1669 12.1589V7.0677Z",
    fill: "#F3F4F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutSourcing);
export default __webpack_public_path__ + "static/media/out-sourcing.6c9a52d38c4bb2c1d95cd20a6118879c.svg";
export { ForwardRef as ReactComponent };